import type { Achievement } from '@/modules/players/v3/types/achievements';

export function getAchievementDetailModalDescription(achievement: Achievement): string {
  return achievement.alreadyAchieved
    ? achievement.accomplishedDescription || achievement.objectiveDescription
    : achievement.objectiveDescription;
}

export function isAchievementDetailNotStarted(achievement: Achievement): boolean {
  return !achievement.alreadyAchieved && achievement.currentValue === 0;
}
